module.exports = __webpack_public_path__ + "assets/settings-9d36f4.svg";